/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingupdatedbutsomeimagesfailedtoupload7Inputs */

const en_listingupdatedbutsomeimagesfailedtoupload7 = /** @type {(inputs: Listingupdatedbutsomeimagesfailedtoupload7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing updated, but some images failed to upload`)
};

const de_listingupdatedbutsomeimagesfailedtoupload7 = /** @type {(inputs: Listingupdatedbutsomeimagesfailedtoupload7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort aktualisiert, aber einige Bilder konnten nicht hochgeladen werden.`)
};

/**
* | output |
* | --- |
* | "Listing updated, but some images failed to upload" |
*
* @param {Listingupdatedbutsomeimagesfailedtoupload7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingupdatedbutsomeimagesfailedtoupload7 = /** @type {((inputs?: Listingupdatedbutsomeimagesfailedtoupload7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingupdatedbutsomeimagesfailedtoupload7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingupdatedbutsomeimagesfailedtoupload7(inputs)
	return de_listingupdatedbutsomeimagesfailedtoupload7(inputs)
});
export { listingupdatedbutsomeimagesfailedtoupload7 as "listingUpdatedButSomeImagesFailedToUpload" }